import React from "react";
import { siteData } from "../data/mockData";
import { CheckCircle2, ScanLine } from "lucide-react";

const WhyChooseUs = () => {
  const { whyChooseUs } = siteData;

  return (
    <section className="w-full bg-white py-16 md:py-24 px-6 md:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left - Doctor Image */}
          <div className="lg:w-[35%] flex justify-center relative">
            <div className="relative">
              {/* Background accent shape */}
              <div className="absolute -bottom-4 -left-4 w-[180px] h-[230px] bg-[#D1D776] rounded-lg opacity-80 -z-0" />
              <img
                src={whyChooseUs.image}
                alt="Doctor"
                className="relative z-10 w-full max-w-[350px] h-auto object-contain"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="lg:w-[65%]">
            <h2 className="font-poppins font-bold text-[1.8rem] md:text-[2.2rem] text-[#1a1a1a] mb-8">
              {whyChooseUs.title}
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-5">
              {whyChooseUs.items.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 group cursor-default"
                >
                  <CheckCircle2 className="w-6 h-6 text-[#1CA0B9] flex-shrink-0 group-hover:scale-110 transition-transform" />
                  <span className="font-poppins text-[#333] font-medium text-[15px] group-hover:text-[#1CA0B9] transition-colors">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom - Motto & Description */}
        <div className="mt-12 md:mt-16">
          <h3 className="font-poppins font-bold text-[1.5rem] md:text-[1.8rem] text-[#1a1a1a] mb-4">
            {whyChooseUs.motto}
          </h3>
          <p className="font-poppins text-[#555] text-sm md:text-[15px] leading-relaxed max-w-5xl">
            At{" "}
            <span className="text-[#1CA0B9] font-medium">
              Anish Total Dental Care
            </span>
            , we are more than just a dental clinic we are a part of your
            community. We understand the importance of trust and transparency in
            healthcare. That's why we take pride in building lasting
            relationships with our patients, based on mutual respect and a shared
            goal of achieving optimal dental health.
          </p>
        </div>

        {/* Technology Spotlight - Trios 3 Scanner */}
        <div className="mt-14 bg-[#F0FAFA] rounded-2xl p-8 md:p-10 flex flex-col md:flex-row gap-8 items-center border border-[#1CA0B9]/15">
          {/* Icon / Visual */}
          <div className="flex-shrink-0">
            <div className="w-20 h-20 rounded-xl bg-[#1CA0B9] flex items-center justify-center shadow-md">
              <ScanLine className="w-10 h-10 text-white" />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1">
            <h4 className="font-poppins font-bold text-[#1a1a1a] text-xl md:text-2xl mb-2">
              Trios 3 Scanner
            </h4>
            <p className="font-poppins text-[#555] text-sm md:text-[15px] leading-relaxed mb-4">
              We use the Trios 3 intraoral scanner to create instant 3D impressions of your upper and lower jaw — no messy impression materials, no gag reflex discomfort. Just fast, precise digital scanning.
            </p>
            <div className="flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-1.5 bg-white px-4 py-2 rounded-full text-sm font-medium text-[#1CA0B9] border border-[#1CA0B9]/20 shadow-sm">
                <CheckCircle2 className="w-4 h-4" />
                100% Accuracy
              </span>
              <span className="inline-flex items-center gap-1.5 bg-white px-4 py-2 rounded-full text-sm font-medium text-[#1CA0B9] border border-[#1CA0B9]/20 shadow-sm">
                <CheckCircle2 className="w-4 h-4" />
                Enhanced Esthetics
              </span>
              <span className="inline-flex items-center gap-1.5 bg-white px-4 py-2 rounded-full text-sm font-medium text-[#1CA0B9] border border-[#1CA0B9]/20 shadow-sm">
                <CheckCircle2 className="w-4 h-4" />
                Faster Lab Delivery
              </span>
              <span className="inline-flex items-center gap-1.5 bg-white px-4 py-2 rounded-full text-sm font-medium text-[#1CA0B9] border border-[#1CA0B9]/20 shadow-sm">
                <CheckCircle2 className="w-4 h-4" />
                No Messy Impressions
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
